import React, { forwardRef, useRef } from 'react'
import useAlienDecodeText from './useAlienDecodeText'

// group consecutive chars by same state
const buildRuns = (displays, states) => {
  const runs = []
  let i = 0
  while (i < displays.length) {
    const state = states[i]
    let chunk = displays[i]
    i++
    while (i < displays.length && states[i] === state) {
      chunk += displays[i]
      i++
    }
    runs.push({ text: chunk, state })
  }
  return runs
}

const AlienDecodeText = forwardRef(({
  text,
  duration = 40,
  scrambleWindow = 60,
  mode = 'ltr',
  autoPlay = false,
  className,
  style,
  onComplete,
}, ref) => {
  const innerRef = useRef()
  const handleRef = ref || innerRef

  const { displays, states } = useAlienDecodeText(handleRef, {
    text,
    duration,
    scrambleWindow,
    mode,
    autoPlay,
    onComplete,
  })

  const runs = buildRuns(displays, states)

  return (
    <span className={className} style={style}>
      {runs.map((run, i) =>
        run.state === 'scrambling'
          ? <span key={i} style={{ color: 'var(--color-text-info, #3b82f6)' }}>{run.text}</span>
          : run.text
      )}
    </span>
  )
})

export default AlienDecodeText
